// import { intcmp } from 'utils/string'
import { freeze } from 'utils/dom'

import { normalizeChallengeInputGroups } from './inputGroup'
import { summarizeJourneyProgress } from './journeyActor'

const defaultAnswer = Object.freeze({
  id: null,
  length: 0,
  status: '',
  version: 1,
  answer: '',
  readyOn: '',
  ready: false,
  acceptedOn: '',
  accepted: false
})

export const ANSWER_STATUS = {
  WORKING: 0,
  SUBMITTED: 1,
  ACCEPTED: 2,
  RETURNED: 3
}

////////////////////////////////////////////////////////////////////////////////
export function normalizeAnswer(newAnswer) {
  let answer = undefined
  if (newAnswer) {
    answer = { ...defaultAnswer, ...newAnswer }
  } else {
    answer = { ...defaultAnswer }
  }
  if (!answer.ready) {
    answer.ready = !!answer.readyOn
  }
  if (!answer.accepted) {
    answer.accepted = !!answer.acceptedOn
  }
  switch (answer.status) {
    case 'submitted':
      answer.statusA = ANSWER_STATUS.SUBMITTED
      break
    case 'returned':
      answer.statusA = ANSWER_STATUS.RETURNED
      break
    case 'accepted':
      answer.statusA = ANSWER_STATUS.ACCEPTED
      break
    default:
      answer.statusA = ANSWER_STATUS.WORKING
      break
  }

  answer.length = answer.answer.length

  return freeze(answer)
}

////////////////////////////////////////////////////////////////////////////////
export function updateAnswer(state, answer) {
  answer = normalizeAnswer(answer)
  const actor = freeze({
    ...state.actor,
    answersD: freeze({ ...state.actor.answersD, [answer.id]: answer }),
    answersInputD: freeze({
      ...state.actor.answersInputD,
      [answer.inputId]: answer.id
    })
  })
  const journey = renormChallengeInputGroups(state.journey, actor)
  const { progress, input2group } = summarizeJourneyProgress(state.journey)

  return freeze({ ...state, actor, journey, input2group, progress })
}

function renormChallengeInputGroups(journey, actor) {
  return freeze({
    ...journey,
    ...normalizeChallengeInputGroups(Object.values(journey.groupsD), actor)
  })
}
